// extracted by mini-css-extract-plugin
module.exports = {"vatInvoiceForm":"ApprovalContent_vatInvoiceForm__1a17M","emailConfirm":"ApprovalContent_emailConfirm__37HNo"};